import { render, staticRenderFns } from "./MyPostulationDetail.vue?vue&type=template&id=7f2f8084&scoped=true"
import script from "./MyPostulationDetail.vue?vue&type=script&lang=ts"
export * from "./MyPostulationDetail.vue?vue&type=script&lang=ts"
import style0 from "./MyPostulationDetail.vue?vue&type=style&index=0&id=7f2f8084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2f8084",
  null
  
)

export default component.exports